import { render, staticRenderFns } from "./five-level.vue?vue&type=template&id=6fa8d460&scoped=true"
import script from "./five-level.vue?vue&type=script&lang=js"
export * from "./five-level.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa8d460",
  null
  
)

export default component.exports